import { Component } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UserIdleService } from 'angular-user-idle';
import { WarningModalComponent } from 'projects/admin/src/app/shared/warning-modal/warning-modal.component';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'public';
  dialogRef: MatDialogRef<WarningModalComponent> | undefined;
  constructor(private dialog: MatDialog, private userIdle: UserIdleService) {}

  ngOnInit() {
    //Start watching for user inactivity.
    this.userIdle.startWatching();

    // Start watching when user idle is starting.
    this.userIdle.onTimerStart().subscribe((count) => {
      // console.log(count);
      if (count && count < 2) {
        this.dialogRef = this.dialog.open(WarningModalComponent, {
          data: {
            title: 'APPLICATION TIMEOUT',
            message: `Your session has been inactive for 10 minutes. The session will timeout after a total of 15 minutes. \n\n Do you wish to continue your session? Click OK to continue.`,
            showCancelButton: false,
          },
          disableClose: true,
        });
        this.dialogRef.afterClosed().subscribe((res: any) => {
          console.log(res);
          this.restart();
        });
      }
    });

    // Start watch when time is up.
    this.userIdle.onTimeout().subscribe(() => {
      console.log('Time is up!');
      window.location.href =
        'https://www.tn.gov/workforce/injuries-at-work/employers/employers/wc-exemption-registry.html';
    });
  }
  startWatching() {
    this.userIdle.startWatching();
  }

  restart() {
    this.userIdle.resetTimer();
  }
}
